import { LogType } from './log-type.enum';

// Allows filtering of logs to specific sources. Main use cases are for VPaaS logs vs app logs, but could be extended.
export enum LogSource {
  VPAAS = 'VPaaS', // "Video Platform as a Service", so we're not assuming a certain provider, i.e. Chime.
  APP = 'App',
  CHAT = 'Chat',
}

export interface ILog {
  logType: LogType;
  datetime: string;
  message: string;
  source: LogSource;
  data?: any;
}

export class Log implements ILog {
  logType: LogType;
  datetime: string;
  message: string;
  source: LogSource;
  data?: any;

  constructor(
    logType: LogType,
    message: string,
    data?: any,
    source?: LogSource
  ) {
    this.datetime = new Date().toISOString();
    this.source = source || LogSource.APP;
    this.logType = logType;
    this.message = message;
    this.data = data;
  }
}
